import { useQuery } from '@apollo/client/react';
import { Table, Tag, Typography } from 'antd';
import dayjs from 'dayjs';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Spacer } from '../../components/Spacer';
import { ADMIN_ORDERS } from '../../gqls/order';
import { executorCategories } from '../../utils';

const TAKE = 50;

export const PageOrders = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const { data, loading } = useQuery(ADMIN_ORDERS, {
    variables: {
      take: TAKE,
      skip: (currentPage - 1) * TAKE,
    },
  });
  const adminOrders = data?.adminOrders || [];
  const adminOrdersCount = data?.adminOrdersCount || 0;

  return (
    <>
      <Typography.Title level={5} style={{ margin: 0 }}>
        Заказы ({adminOrdersCount})
      </Typography.Title>
      <Spacer h={12} />
      <ContentTable>
        <Table
          size="middle"
          loading={loading}
          dataSource={adminOrders}
          columns={[
            {
              key: 'number',
              dataIndex: 'number',
              title: 'ID',
              render: (number, order) => <Link to={`/orders/${order.id}`}>{number}</Link>,
            },
            {
              key: 'datetime',
              dataIndex: 'datetime',
              title: 'Дата/время',
              render: (date) => dayjs(date).format('DD.MM.YYYY HH:mm'),
            },
            {
              key: 'category',
              dataIndex: 'category',
              title: 'Категория',
              render: (category, order) => (
                <Tag>
                  {executorCategories.find((item) => item.value === category)?.singleLabel || ''}
                  {order.category === 'heavy-truck'
                    ? ` ${order.heavyTruckType === 'trawl' ? '(Трал)' : '(Полуприцеп)'}`
                    : ''}
                </Tag>
              ),
            },
            {
              key: 'fullAddress',
              dataIndex: 'fullAddress',
              title: 'Город и адрес',
            },
            {
              key: 'status',
              dataIndex: 'status',
              title: 'Статус',
              render: (status) => {
                // searching, active, done, cancelled, expired
                if (status === 'searching') return <Tag color="blue">Поиск исполнителя</Tag>;
                if (status === 'active') return <Tag color="green">Активный</Tag>;
                if (status === 'done') return <Tag color="gray">Выполнен</Tag>;
                if (status === 'cancelled') return <Tag color="red">Отменен</Tag>;
                if (status === 'expired') return <Tag color="orange">Истек срок</Tag>;
                return <Tag>{status}</Tag>;
              },
            },
            {
              key: 'price',
              dataIndex: 'price',
              title: 'Цена',
              render: (price, order) => {
                const selectedOffer = order.offers?.find((offer) => offer.status === 'selected');
                if (selectedOffer) return `${selectedOffer.price} ₽`;
                return `${price} ₽`;
              },
            },
          ]}
          pagination={{
            current: currentPage,
            total: adminOrdersCount,
            pageSize: TAKE,
            onChange: (page) => {
              setCurrentPage(page);
            },
          }}
        />
      </ContentTable>
    </>
  );
};

const ContentTable = styled.div`
  overflow-x: auto;

  table {
    min-width: 1100px;
  }
`;

// const Filter = styled.div`
//   display: flex;
//   flex-direction: row;
// `;
